import React from "react"
import {
  CONTEXT_MODE_OPTIONS,
  DEFAULT_CONTEXT_MODE,
} from "../utils/contextModes"
import "../../../../component/student/LearnerField.style.scss"

interface ContextModeSelectProps {
  value: string
  disabled?: boolean
  onChange: (value: string) => void
}

const ContextModeSelect = ({
  value,
  disabled = false,
  onChange,
}: ContextModeSelectProps) => (
  <div className="learner-field">
    <label htmlFor="practice-paper-context-mode" className="learner-field__label">
      Context mode
    </label>
    <div className="learner-field__control">
      <select
        id="practice-paper-context-mode"
        name="context_mode"
        className="learner-field__input learner-field__select"
        value={value || DEFAULT_CONTEXT_MODE}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        {CONTEXT_MODE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  </div>
)

export default ContextModeSelect
